module.exports = __webpack_public_path__ + "static/441a59.jpg";